
import React from 'react';
import { ThemeToggle } from '@/components/ui/theme-toggle';
import { CompanySelector } from '@/components/company/CompanySelector';
import { useCompany } from '@/context/CompanyContext';
import { Button } from '@/components/ui/button';
import { Store, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

interface CaisseLayoutProps {
  children: React.ReactNode;
  title: string;
  actions?: React.ReactNode;
  sidebarTrigger?: React.ReactNode;
}

export const CaisseLayout: React.FC<CaisseLayoutProps> = ({ 
  children, 
  title, 
  actions,
  sidebarTrigger 
}) => {
  const { currentCompany, userRole } = useCompany();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/auth');
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header simplifié pour la caisse */}
      <header className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50">
        <div className="flex h-16 items-center gap-4 px-4">
          {userRole !== 'admin' && (
            <Button
              variant="ghost"
              size="sm"
              onClick={handleLogout}
              className="flex items-center gap-2"
            >
              <LogOut className="h-4 w-4" />
              Déconnexion
            </Button>
          )}
          
          <div className="flex-1 flex items-center justify-between">
            <div className="flex items-center gap-4">
              {sidebarTrigger}
              <div className="flex items-center gap-2">
                <Store className="h-5 w-5 text-primary" />
                <h1 className="text-xl font-semibold">
                  {title}
                </h1>
              </div>
              {currentCompany && (
                <div className="text-sm text-muted-foreground">
                  {currentCompany.name}
                </div>
              )}
              <CompanySelector />
            </div>
            
            <div className="flex items-center gap-4">
              {actions}
            </div>
          </div>
        </div>
      </header>

      {/* Contenu principal */}
      <main className="flex-1 p-4">
        {children}
      </main>
    </div>
  );
};
